import { coursesApi } from "@services/apiMembersClient";
import { GetCoursesInput, GetCoursesOutput } from "@_types/courses";
import { AxiosPromise } from "axios";

export const getCourses = ({}: GetCoursesInput): AxiosPromise<GetCoursesOutput> => {
  return coursesApi.get(`/courses`);
};
